import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { PayoutSettingsRouter } from "./Router";

export function PayoutSettingsContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PayoutSettingsRouter />
    </ThemeProvider>
  );
}
